<template>
  <div class="headerView">
    <div v-show="loading" class="loading flexCC font20">
      <i class="iconfont icon-loading"></i>
      请稍候，资源加载中...
    </div>

    <div class="topDiv flexSB tran">
      <div class="flexCS">
        <img
          class="cur"
          src="@/assets/img/homeIcon.png"
          @click="$router.push('/')"
        />
        <button v-if="isShowMenu" class="flexCC font20 tran cur mr-10" @click="$router.push('/aiSearchInfo')">
          <span class="font20">图形相似搜索</span>
        </button>
        <button
          v-if="isShowMenu"
          class="flexCC font20 tran cur mr-10"
          @click="$router.push('/aiSearchK')"
        >
          <span class="font20">AlPha-K</span>
        </button>
      </div>
      <span class="font40 fw"></span>
      <div class="flexCS" v-if="isShowMenu">
        <button
          class="flexCC font20 tran cur"
          @click="$router.push('/aiSearchV')"
        >
          <span class="font20">AlPha-V</span>
        </button>
        <button
          class="flexCC font20 tran cur"
          @click="$router.push('/aiSearchM')"
        >
          <span class="font20">AlPha-M</span>
        </button>
        <UserDropdownMenu />
      </div>
    </div>
  </div>
</template>
<script>
import UserDropdownMenu from "./userDropdownMenu.vue";
export default {
  components: {
    UserDropdownMenu,
  },
  props: {
    loading: Boolean,
    isShowMenu: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.headerView {
  color: #fff;
  background: url("@/assets/img/mainBg.png") no-repeat;
  background-size: 100% 100%;
  background-color: #0d121d;

  .loading {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: rgba($color: #000, $alpha: 0.95);
    position: fixed;
    top: 0;
    right: 0;
    z-index: 999;

    > i {
      overflow: hidden;
      margin: 0 1rem 0 0;
      color: #fff;
      animation: rotate360 linear 1.5s infinite;
    }
  }

  > .topDiv {
    width: 100%;
    height: 10rem;
    padding: 3rem 3rem 0 3rem;
    background: url("@/assets/img/mainTopBg.png") no-repeat;
    background-size: 100% 100%;

    > div {
      height: auto;

      &:last-child > button {
        background: url("@/assets/img/mainTopBtn2.png") no-repeat center bottom;
        background-size: 100% auto;

        &:first-child {
          margin: 0 -2rem 0 0;
        }

        &:hover,
        &.active {
          background: url("@/assets/img/mainTopBtn2A.png") no-repeat center
            bottom;
          background-size: 100% auto;
        }

        &.alpha-m {
          background: url("@/assets/img/mainTopBtn-alpha-m.png") no-repeat
            center bottom;
          background-size: 100% auto;
        }
      }

      > img {
        width: 10rem;
        height: 3.5rem;
        overflow: hidden;
        margin: 0 1rem 0 0;
      }

      > button {
        width: 24rem;
        height: 4.4rem;
        overflow: hidden;
        // padding: 0 0 1rem 0;
        color: #acb2b9;
        font-family: "designFont";
        background: url("@/assets/img/mainTopBtn.png") no-repeat center bottom;
        background-size: 100% auto;

        &:last-child {
          margin: 0 0 0 -2rem;
        }

        &:hover,
        &.active {
          color: #fff;
          background: url("@/assets/img/mainTopBtnA.png") no-repeat center
            bottom;
          background-size: 100% auto;
        }
      }
    }

    > span {
      overflow: hidden;
      letter-spacing: 0.5rem;
    }
  }
}

@media screen and (max-width: 980px) {
  .aiSearchVView {
    //

    > .topDiv {
      height: 6rem;
      padding: 1rem 1rem 0 1rem;

      > div {
        //

        > img {
          padding: 1rem;
          margin: 0;
        }

        > button {
          width: 13rem;
          height: 3rem;
          padding: 0 0 0 1rem;
          margin: 0 0 0 -2rem;
          font-size: 1rem;
        }

        .userDiv > ul {
          height: calc(100vh - 10rem);
          overflow-y: auto;
        }
      }

      > span {
        font-size: 2rem;
      }
    }
  }
}
</style>